import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

const OpenFolderIcon = ({
  color = '#0D84FE',
  width = 28,
  height = 16,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 16"
    width={width}
    height={height}
    {...props}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M17.38 14.027l1.964-9.422H17.42V3.93c0-1.144-.93-2.075-2.074-2.075H8.21L6.167 0H2.074C.93 0 0 .93 0 2.074v11.852C0 15.07.93 16 2.074 16h13.273c.01 0 .02-.003.032-.004 1.078-.034 1.95-.894 2-1.97zm-15.892-.1V2.072c0-.323.262-.585.586-.585h3.518l2.04 1.854h7.714c.323 0 .585.262.585.586v.677H4.45l-1.925 9.907h-.452c-.323 0-.585-.263-.585-.586zm2.553.585l1.637-8.42h11.838l-1.6 7.682c-.006.034-.008.07-.01.104-.002.016-.006.032-.006.048v.002c0 .323-.263.585-.587.585H4.04z"
    />
  </svg>
);

OpenFolderIcon.propTypes = propTypes;

export default OpenFolderIcon;
